module.exports = __webpack_public_path__ + "static/scale-model-of-boulder-arts-&-crafts-gallery-in-boulder-colorado-2b7d7c04cb264b7d722020989e09aa49.png";